





import { defineComponent, inject } from "vue";
import getCurrentView from "@/composition/getCurrentView";
import useMatomoEvent from "@/composition/useMatomoEvent";

export default defineComponent({
  setup() {
    const eventBus: Vue = inject("eventBus");
    function openModal() {
      eventBus.$emit("openCollabDialog", "create");

      useMatomoEvent({
        category: `${getCurrentView()} View`,
        action: 'Click "Neue Mappe"',
        name: `Neue Mappe Collab in ${getCurrentView()}-View`
      });
    }
    return { openModal };
  }
});
